import React from 'react';

export default function PixelVisorSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Visor frame */}
      <rect x="3" y="16" width="34" height="10" rx="1" fill="#212121" />
      {/* Inner screen area */}
      <rect x="5" y="18" width="30" height="6" fill="#000" />
      {/* Rainbow pixel stripes */}
      <rect x="5" y="18" width="5" height="6" fill="#FF1744" />
      <rect x="10" y="18" width="5" height="6" fill="#FF9100" />
      <rect x="15" y="18" width="5" height="6" fill="#FFEA00" />
      <rect x="20" y="18" width="5" height="6" fill="#00E676" />
      <rect x="25" y="18" width="5" height="6" fill="#00B0FF" />
      <rect x="30" y="18" width="5" height="6" fill="#D500F9" />
      {/* Pixel grid overlay */}
      <rect x="9.5" y="18" width="0.5" height="6" fill="#000" opacity="0.5" />
      <rect x="14.5" y="18" width="0.5" height="6" fill="#000" opacity="0.5" />
      <rect x="19.5" y="18" width="0.5" height="6" fill="#000" opacity="0.5" />
      <rect x="24.5" y="18" width="0.5" height="6" fill="#000" opacity="0.5" />
      <rect x="29.5" y="18" width="0.5" height="6" fill="#000" opacity="0.5" />
      <rect x="5" y="20.8" width="30" height="0.5" fill="#000" opacity="0.4" />
      {/* Side mount tabs */}
      <rect x="2" y="19" width="2" height="4" rx="0.5" fill="#424242" />
      <rect x="36" y="19" width="2" height="4" rx="0.5" fill="#424242" />
      {/* Top highlight */}
      <rect x="5" y="18" width="30" height="0.8" fill="white" opacity="0.25" />
    </svg>
  );
}
